import { GET_USER_STATE_REQUEST, GET_USER_STATE_SUCCESS, GET_USER_STATE_ERROR } from 'actions/userStateActions';
import { ADD_WISHLIST_ITEM_SUCCESS, REMOVE_WISHLIST_ITEM_SUCCESS } from 'actions/wishlistActions';
import { PRODUCT_DETAIL_SUCCESS } from 'actions/productDetailsActions';
import { PINCODE_REQUEST } from 'actions/pincodeActions';
import {
	REMOVE_FROM_CART,
	UNDO_DELETE_FROM_CART,
	REMOVE_FROM_BASKET,
	CHANGE_QUANTITY_IN_BASKET,
	UNDO_DELETE_FROM_BASKET
} from 'actions/CartActions/UpdateCartActions';
import { ADD_TO_CART } from 'actions/CartActions/AddToCartActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { GET_MARK_ALL_READ_SUCCESS } from 'actions/inAppNotificationsActions';
import { MyPersonalInfo } from 'actions/MyAccountActions/MyProfileInfoActions/myPersonalInfoActions';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { removeArrayItems } from 'utils/arrayHelper';
import get from 'lodash/get';
import { getCartItemsFromCartDetails, segregateItemsOnMarketplace } from 'utils/cartUtils';
import { basketActionsEnum } from 'actions/basketActions';

import { pageTypes } from 'constants/pageTypes';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { MOVE_TO_CART_FROM_SFL, MOVE_TO_SFL_FROM_CART } from 'actions/CartActions/CartSFLActions';
import { MarketplaceId } from '@rome/request/marketplace/MarketplaceId';
import { MODAL_PAGE_DATA_ACTIONS } from 'actions/V4Actions/v4ActionModal';
import { AFFILIATE_LOGGING_SUCCESS } from 'actions/affiliateLoggingActions';
import { APP_LAUNCH_DATA_SUCCESS, isValidOmnitureInfo } from 'actions/appLaunchActions';

export default function userState(
	state = {
		cart: {
			items: [],
			latestBasketBuildingItem: null,
			fkItems: [],
			groceryItems: []
		},
		asyncStatus: AsyncStatus.INIT
	},
	action = null
) {
	let fkItems = [];
	let groceryItems = [];
	switch (action.type) {
		case GET_USER_STATE_REQUEST:
			return Object.assign({}, state, { asyncStatus: AsyncStatus.LOADING, error: null });
		case GET_USER_STATE_ERROR:
			return Object.assign({}, state, { asyncStatus: AsyncStatus.ERROR, error: action.error });
		case GET_USER_STATE_SUCCESS:
			(get(action.data['RESPONSE'], ['cart', 'items']) || []).forEach(storeType => {
				switch (storeType.marketplace) {
					case MarketplaceId.GROCERY:
						groceryItems.push({ ...storeType, listingId: storeType.listId });
						break;
					case MarketplaceId.FLIPKART:
					default:
						fkItems.push({ ...storeType, listingId: storeType.listId });
						break;
				}
			});

			return {
				...state,
				asyncStatus: AsyncStatus.SUCCESS,
				...action.data['RESPONSE'],
				...action.data['SESSION'],
				cart: {
					fkItems,
					groceryItems,
					// Added this to reduce the code changes across the application consuming cart.items
					// This would require all the updates to cart to update this items array manually
					// TODO: Need to remove this items array and extract info from fkItems and groceryItems
					items: [...fkItems, ...groceryItems]
				},
				omnitureInfo: get(action.data['META_INFO'], 'omnitureInfo'),
				pincode: get(action.data['RESPONSE'], ['location', 'selectedLocation', 'pincode']),
				userEmail: get(action.data['SESSION'], ['email']),
				error: null
			};
		case MODAL_PAGE_DATA_ACTIONS.SUCCESS: {
			const basketItems = get(action, 'actionResponseContext.cartResponseMeta');
			if (!basketItems) return state;
			const fkItems = get(state, 'cart.fkItems') || [];
			const groceryItems = Object.keys(basketItems)
				.map(id => basketItems[id])
				.filter(item => Boolean(item.quantity));
			return {
				...state,
				cart: {
					fkItems,
					groceryItems,
					items: [...fkItems, ...groceryItems]
				}
			};
		}

		case AFFILIATE_LOGGING_SUCCESS:
			return {
				...state,
				sn: action.snValue
			};

		case APP_LAUNCH_DATA_SUCCESS:
			let omnitureInfo = state.omnitureInfo;
			if (isValidOmnitureInfo(omnitureInfo)) {
				omnitureInfo = action.data;
			}
			return { ...state, omnitureInfo };

		case PAGE_DATA_ACTIONS.SUCCESS: {
			if (get(action, 'data.slots') && action.pageType && action.pageType === pageTypes.Product) {
				const pincodeSlot = (get(action.data, 'slots') || []).find(slot => {
					return get(slot, 'widget.type') === WidgetTypeV4.COMPOSED_PINCODE_DELIVERY;
				});
				if (pincodeSlot) {
					state = Object.assign({}, state, {
						pincode: get(pincodeSlot, 'widget.data.pincodeData.pincodeComponent.value.pincode') || state.pincode
					});
				}
			}
			const cartItems = get(action, 'actionResponseContext.cartResponseMeta');
			if (cartItems) {
				const fkItems = [];
				const groceryItems = [];
				Object.keys(cartItems).forEach(id => {
					switch (cartItems[id].marketplace) {
						case MarketplaceId.GROCERY:
							groceryItems.push(cartItems[id]);
							break;
						case MarketplaceId.FLIPKART:
							fkItems.push(cartItems[id]);
							break;
					}
				});
				state = Object.assign({}, state, {
					cart: {
						fkItems,
						groceryItems,
						items: [...fkItems, ...groceryItems]
					}
				});
			}
			return state;
		}
		case ADD_WISHLIST_ITEM_SUCCESS: {
			let newItems = action.data['AddedItems'] || [];
			let productIds = [...state.wishlist.productIds, ...newItems];
			return Object.assign({}, state, {
				wishlist: {
					...state.wishlist,
					totalElements: productIds.length,
					productIds
				}
			});
		}
		case REMOVE_WISHLIST_ITEM_SUCCESS: {
			let productIds = removeArrayItems(state.wishlist.productIds, action.data['RemovedItems']);
			return Object.assign({}, state, {
				wishlist: {
					...state.wishlist,
					totalElements: productIds.length,
					productIds
				}
			});
		}
		case PRODUCT_DETAIL_SUCCESS:
			return Object.assign({}, state, {
				pincode: get(action, ['data', 'data', 'product_pincode_1', 'data', '0', 'value', 'pincode']) || state.pincode
			});
		case REMOVE_FROM_BASKET.SUCCESS:
		case CHANGE_QUANTITY_IN_BASKET.SUCCESS:
		case UNDO_DELETE_FROM_BASKET.SUCCESS: {
			const groceryItems = get(action, ['data', 'cartDetails', 'requestedStores', 0, 'buyableStateItems']) || [];
			return {
				...state,
				cart: {
					fkItems: state.cart.fkItems || [],
					groceryItems,
					items: [...(state.cart.fkItems || []), ...groceryItems]
				}
			};
		}
		case basketActionsEnum.ADD_TO_BASKET_SUCCESS:
		case basketActionsEnum.EDIT_ITEM_QUANTITY_IN_BASKET_SUCCESS: {
			const cartData = get(action, ['data', 'cartData']) || {};
			return {
				...state,
				cart: segregateItemsOnMarketplace(cartData)
			};
		}
		case ADD_TO_CART.SUCCESS:
			const cartData = get(action, ['data', 'cartResponse']) || {};
			return {
				...state,
				cart: segregateItemsOnMarketplace(cartData)
			};
		case ADD_TO_CART.SET_LATEST_BASKET_BUILDING_ITEM:
			const { listingId, imageUrl, basketBuildingTimeoutId } = action.data;
			return Object.assign({}, state, {
				cart: {
					...state.cart,
					latestBasketBuildingItem: {
						listingId,
						imageUrl,
						basketBuildingTimeoutId
					}
				}
			});
		case ADD_TO_CART.RESET_LATEST_BASKET_BUILDING_ITEM:
			return Object.assign({}, state, {
				cart: {
					...state.cart,
					latestBasketBuildingItem: null,
					basketBuildingTimeoutId: null
				}
			});
		case UNDO_DELETE_FROM_CART.SUCCESS:
		case REMOVE_FROM_CART.SUCCESS: {
			const cartItems = getCartItemsFromCartDetails(get(action, ['data', 'cartDetails']) || {});
			return {
				...state,
				cart: {
					...cartItems,
					items: [...cartItems.groceryItems, ...cartItems.fkItems]
				}
			};
		}
		case MOVE_TO_SFL_FROM_CART.SUCCESS: {
			const cartToSflData = get(action, ['data', 'detailedCart', 'cartDetails']) || {};
			const cartItems = getCartItemsFromCartDetails(cartToSflData);
			return {
				...state,
				cart: {
					...cartItems,
					items: [...cartItems.groceryItems, ...cartItems.fkItems]
				}
			};
		}
		case MOVE_TO_CART_FROM_SFL.SUCCESS: {
			const sflToCartData = get(action, ['data', 'response', 'detailedCart', 'cartDetails']) || {};
			const cartItems = getCartItemsFromCartDetails(sflToCartData);
			return {
				...state,
				cart: {
					...cartItems,
					items: [...cartItems.groceryItems, ...cartItems.fkItems]
				}
			};
		}
		case PINCODE_REQUEST.UPDATE_PINCODE:
			return { ...state, pincode: action.pincode };
		case GET_MARK_ALL_READ_SUCCESS:
			return Object.assign({}, state, {
				notifications: {
					...state.notifications,
					unreadCount: 0
				}
			});
		case MyPersonalInfo.SUCCESS:
			return Object.assign({}, state, {
				firstName: action.data.firstName,
				lastName: action.data.lastName,
				userService: {
					...state.userService,
					gender: action.data.gender
				}
			});
		default:
			return state;
	}
}
